document.addEventListener("DOMContentLoaded", function() {
  const article = document.querySelector("article.group");

  if (!article) return; // .group クラスのある <article> がなければ処理をしない

  const movieBtn = document.querySelector(".js-movieBtn");
  const movieOver = document.querySelector(".groupMovie__over");
  const iframe = document.querySelector(".groupMovie__video iframe");

  if (movieBtn && movieOver && iframe) {
      movieBtn.addEventListener("click", function() {
          // iframeのsrcを変更して動画を再生
          let src = iframe.getAttribute("src");
          if (!src.includes("autoplay=1")) {
              src += (src.includes("?") ? "&" : "?") + "autoplay=1";
              iframe.setAttribute("src", src);
          }
          // 0.3秒後にオーバーレイを非表示
          setTimeout(() => {
              movieOver.style.display = "none";
          }, 300);
      });
  }
});
